export default __webpack_public_path__ + "static/media/vector-square-back.93040d20.png";